import { useEffect, useState } from 'react'

/** True while the media query matches; tracks orientation and window changes. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false))
  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = () => setMatches(mq.matches)
    setMatches(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])
  return matches
}

const LANDSCAPE_PHONE = '(orientation: landscape) and (min-width: 640px) and (max-width: 1300px) and (max-height: 500px)'

/** True on phones: narrow viewports, or a wide phone turned sideways. Mirrors the CSS breakpoints. */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: 900px), ${LANDSCAPE_PHONE}`)
}

/** A phone turned sideways: wide enough for two columns, too short for tall charts. */
export function useLandscapePhone(): boolean {
  return useMediaQuery(LANDSCAPE_PHONE)
}
